import MyAiWorksItem from "@/components/creatorcenter/myaiworksitem";
import { Content } from "@/types/content";
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  useBreakpointValue,
  Text,
  Select,
  SimpleGrid,
} from "@chakra-ui/react";
import { useState } from "react";
import { SlMagnifier } from "react-icons/sl";
import WorksItemImg from "@/assets/images/creator_img5.png";
import { RiMagicLine } from "@remixicon/react";
import { useNavigate } from "react-router-dom";

const MyAiWorks = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");

  const searchWidth = useBreakpointValue({
    base: "160px",
    md: "220px",
    lg: "400px",
  });

  const column = useBreakpointValue({
    base: 1, // 屏幕宽度小于40em（640px）时的值
    sm: 1,   // 屏幕宽度在40em-52em（640px-853px）之间时的值
    md: 1,   // 屏幕宽度在52em-64em（853px-1024px）之间时的值
    lg: 2,   // 屏幕宽度在64em-80em（1024px-1280px）之间时的值
    xl: 3,  // 屏幕宽度在80em-100em（1280px-1920px）之间时的值
  })

  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const WorksList: Content[] = [
    {
      id: "mw555zq4ujrgtj1189uxuwkika",
      prompt: "梦幻空间 彩色 水母",
      image_url: `${WorksItemImg}`,
      like_num: 21,
      collect_num: 2,
      page_view: 210,
      onekey_nums: 20,
    },{
      id: "2",
      prompt: "梦幻空间 彩色 水母",
      image_url: `${WorksItemImg}`,
      like_num: 21,
      collect_num: 2,
      page_view: 210,
      onekey_nums: 20,
    },{
      id: "3",
      prompt: "梦幻空间 彩色 水母",
      image_url: `${WorksItemImg}`,
      like_num: 21,
      collect_num: 2,
      page_view: 210,
      onekey_nums: 20,
    },{
      id: "4",
      prompt: "梦幻空间 彩色 水母",
      image_url: `${WorksItemImg}`,
      like_num: 21,
      collect_num: 2,
      page_view: 210,
      onekey_nums: 20,
    }
  ] as Content[];

  return (
    <Box h="100%" pl="20px" pr="20px">
      <Box
        h="100%"
        overflow={"auto"}
        borderWidth="1px"
        borderColor={"#DCE0EB"}
        p="20px"
      >
        <Flex mb="30px" justifyContent={"space-between"} alignItems="center">
          <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            我的AI创作
          </Box>
          <HStack>
            <InputGroup w={searchWidth}>
              <Input
                h="40px"
                boxSizing="border-box"
                border="1px solid #CBD1DF"
                borderRadius={0}
                bg="none"
                color={"#8E94A9"}
                fontSize="12px"
                placeholder="请输入"
                size="md"
                value={searchValue}
                onChange={handleChangeSearchValue}
              />
              <InputRightElement>
                <SlMagnifier color="#CBD1DF" />
              </InputRightElement>
            </InputGroup>
            <Button
              borderRadius={0}
              width={"90px"}
              height={"40px"}
              color="#FFFFFF"
              bgColor="#496AE1"
              fontWeight={"normal"}
              fontSize="12px"
              _hover={{
                bgColor: "#3F5BC1",
                color: "#E6E6E6",
              }}
              leftIcon={<RiMagicLine size={"16px"} />}
              onClick={()=> navigate("/ai/design")}
            >
              在线创作
            </Button>
          </HStack>
        </Flex>
        <Flex
          mb="20px"
          justifyContent={"space-between"}
          alignItems="center"
          borderBottom={"1px solid #CBD1DF"}
        >
          <Box
            fontSize={"16px"}
            color={"#27314D"}
            borderColor="#27314D"
            borderBottom={"4px"}
          >
            全部内容
          </Box>
          <Flex alignItems={"center"}>
            <Text fontSize={"12px"} color={"#8E94A9"}>
              筛选条件:{" "}
            </Text>
            <Select
              color={"#27314D"}
              fontSize={"12px"}
              w="100px"
              border={"none"}
              size="xs"
            >
              <option>全部作品</option>
            </Select>
            <Box ml={"30px"} fontSize={"13px"} color={"#27314D"}>
              共40个内容
            </Box>
          </Flex>
        </Flex>
        <Box>
          <SimpleGrid columns={column} spacing={"40px 20px"}>
            {WorksList &&
              WorksList.map((item) => {
                return (
                  <Box key={item.id} >
                    <MyAiWorksItem works={item} />
                  </Box>
                );
              })}
          </SimpleGrid>
        </Box>
      </Box>
    </Box>
  );
};

export default MyAiWorks;
